module.exports = __webpack_public_path__ + "static/media/enterprice.4f80c751.svg";